<template>
  <div class="app-disclaimer" v-if="isIE">
    <span class="app-disclaimer__bg" />
    <p class="app-disclaimer__content" v-html="$translate('layout').disclaimer"/>
  </div>
</template>

<script>
import { isIE } from '@/scripts/utils';

export default {
  name: 'AppDisclaimer',

  data() {
    return {
      isIE: isIE(),
    };
  },
};
</script>

<style lang="scss" scoped>
.app-disclaimer {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;

  background-color: $color-bg;

  display: flex;
  align-items: center;
  justify-content: center;

  z-index: 101;

  &__bg {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;

    background-image: url('/img/illustrations/bg_mobile.png');
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center center;

    opacity: 0.25;
  }

  &__content {
    position: relative;
    width: 100%;
    padding: 0 20px;
    box-sizing: border-box;
  }

  @include mq(ipadP) {
    &__bg {
      background-image: url('/img/illustrations/bg_desktop.png');
    }

    &__content {
      width: calc(var(--unit-vw) * 10);
      padding: 0 var(--unit-vw);
    }
  }
}
</style>
